export default __webpack_public_path__ + "static/media/f2.9a96188e.svg";